<div class="split-container">
  <!-- BRANDING PANE (Left/Top) -->
  <div class="brand-pane">
    <div class="brand-header">
      <div class="logo-area">
        <img class="logo-img" src="assets/images/aims-logo.svg" />
      </div>
    </div>

    <div class="brand-content">
      <h1 class="brand-heading">
        {{ translator("password-welcome-password-creation") }}
      </h1>
      <p class="brand-subtext">
        {{ translator("password-create-secure-password") }}
        <br />
        {{ translator("password-secure-account-password-note") }}
      </p>
    </div>

    <div class="brand-footer">
      <img
        class="image-prowred-by"
        src="assets/images/poweredbywissenswerft.svg"
      />
      <p class="imprint-text">
        {{ translator("password-imprint-text") }}
      </p>
    </div>
  </div>

  <!-- FORM PANE (Right/Bottom) -->
  <div class="form-pane">
    <div class="form-card">
      @if (isSuccess()) {
        <!-- Success State -->
        <div class="success-message fade-in">
          <div class="success-icon-circle">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>
          <h2 class="form-title" style="color: #166534; margin-bottom: 1rem">
            {{ dataService.res("password-success-title") }}
          </h2>
          <p class="form-subtitle" style="margin-bottom: 2rem">
            {{ dataService.res("password-success-text") }}
          </p>
          <ubt-loader></ubt-loader>
        </div>
      } @else if (isSessionExpired()) {
        <!-- Success State -->
        <div class="error-message fade-in">
          <div class="error-icon-circle">
            <svg
              width="256px"
              height="256px"
              viewBox="0 0 48 48"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              stroke="none"
            >
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                <title>expire-solid</title>
                <g id="Layer_2" data-name="Layer 2">
                  <g id="icons_Q2" data-name="icons Q2">
                    <g>
                      <rect width="48" height="48" fill="none"></rect>
                      <g>
                        <path
                          d="M14.2,31.9h0a2,2,0,0,0-.9-2.9A11.8,11.8,0,0,1,6.1,16.8,12,12,0,0,1,16.9,6a12.1,12.1,0,0,1,11.2,5.6,2.3,2.3,0,0,0,2.3.9h0a2,2,0,0,0,1.1-3,15.8,15.8,0,0,0-15-7.4,16,16,0,0,0-4.8,30.6A2,2,0,0,0,14.2,31.9Z"
                        ></path>
                        <path
                          d="M16.5,11.5v5h-5a2,2,0,0,0,0,4h9v-9a2,2,0,0,0-4,0Z"
                        ></path>
                        <path
                          d="M45.7,43l-15-26a2,2,0,0,0-3.4,0l-15,26A2,2,0,0,0,14,46H44A2,2,0,0,0,45.7,43ZM29,42a2,2,0,1,1,2-2A2,2,0,0,1,29,42Zm2-8a2,2,0,0,1-4,0V26a2,2,0,0,1,4,0Z"
                        ></path>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <h2 class="form-title">
            {{ translator("password-session-expired-error-title") }}
          </h2>
          <p class="form-subtitle" style="margin-bottom: 2rem">
            {{
              currentRoutePath === "register/:id"
                ? translator("password-session-expired-error-message")
                : translator("password-reset-session-expired-error-message")
            }}
          </p>
          <a routerLink="/login" class="back-link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m12 19-7-7 7-7" />
              <path d="M19 12H5" />
            </svg>
            {{ dataService.res("back-to-login") }}
          </a>
        </div>
      } @else {
        <!-- Form State -->
        <div class="fade-in">
          <div class="form-header">
            <h2 class="form-title">
              {{ dataService.res("password-set-password-title") }}
            </h2>
            <p class="form-subtitle">
              {{ dataService.res("password-condition-text") }}
            </p>
          </div>

          <!-- User Provided Form Structure -->
          <abc-register
            #formContainer
            (onSubmit)="onUserSubmit($event)"
            [passwordMinLength]="8"
          ></abc-register>
          <!-- End User Structure -->

          <p class="contact-support">
            {{ dataService.res("password-contact-support-note") }}
            <a href="" class="contact-support-btn">
              <strong class="support-style">{{
                dataService.res("password-support-text")
              }}</strong></a
            >
          </p>
          <a routerLink="/login" class="back-link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m12 19-7-7 7-7" />
              <path d="M19 12H5" />
            </svg>
            {{ dataService.res("back-to-login") }}
          </a>
        </div>
      }
    </div>
  </div>
</div>
